// Mudbutt Brew - Authentic Product Catalog

export const teas = [
  {
    id: 1,
    name: "Forge Black",
    purpose: "Bold Energy & Focus",
    description: "Blacksmith's Brew. Bold energy & mental clarity",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/forge_black_page-1.png",
    imageBack: "/labels/forge_black_page-2.png",
    benefits: ["Energy", "Focus", "Contains Caffeine"],
    warning: "Contains caffeine - Avoid late if sensitive",
    badge: "bestseller",
    inStock: true
  },
  {
    id: 2,
    name: "Leaf Forge",
    purpose: "Pure Green Focus",
    description: "Herbal Fire. Body Fuel. Pure Japanese Sencha green tea",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/leaf_forge_new_page-1.png",
    imageBack: "/labels/leaf_forge_new_page-2.png",
    benefits: ["Focus", "Energy", "Contains Caffeine"],
    warning: "Contains caffeine - Avoid late if sensitive",
    inStock: true
  },
  {
    id: 3,
    name: "Elder & Fire",
    purpose: "Immune Kick",
    description: "Herbal Fire. Body Fuel. Powerful immune support blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/elder_fire_page-1.png",
    imageBack: "/labels/elder_fire_page-2.png",
    benefits: ["Immune Support", "Antioxidant Rich", "Warming"],
    warning: "Contains Mullein - Must be strained with fine mesh or coffee filter",
    badge: "popular",
    inStock: true
  },
  {
    id: 4,
    name: "Sleep Whisper",
    purpose: "Night Drop",
    description: "Dreamy Herbs. Restful Sleep. Deep relaxation blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/sleep_whisper_page-1.png",
    imageBack: "/labels/sleep_whisper_page-2.png",
    benefits: ["Deep Sleep", "Calming", "Stress Relief"],
    badge: "bestseller",
    inStock: true
  },
  {
    id: 5,
    name: "Flush Fire",
    purpose: "Toxin Burn",
    description: "Cleanse & Renew. Natural detoxification support",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/flush_fire_page-1.png",
    imageBack: "/labels/flush_fire_page-2.png",
    benefits: ["Detox Support", "Cleansing", "Purifying"],
    badge: "popular",
    inStock: true
  },
  {
    id: 6,
    name: "Citrus Glow",
    purpose: "Vitamin Surge",
    description: "Bright & Zesty. Natural vitamin C powerhouse",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/citrus_glow_page-1.png",
    imageBack: "/labels/citrus_glow_page-2.png",
    benefits: ["Vitamin C", "Immunity", "Antioxidants"],
    inStock: true
  },
  {
    id: 7,
    name: "Gut Glow",
    purpose: "Digestion Fix",
    description: "Soothe & Restore. Digestive comfort blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/gut_glow_page-1.png",
    imageBack: "/labels/gut_glow_page-2.png",
    benefits: ["Digestive Aid", "Soothing", "Comfort"],
    inStock: true
  },
  {
    id: 8,
    name: "Lung Moon",
    purpose: "Breath Clear",
    description: "Breathe Easy. Respiratory support blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/lung_moon_page-1.png",
    imageBack: "/labels/lung_moon_page-2.png",
    benefits: ["Respiratory", "Clear Breathing", "Soothing"],
    warning: "Contains Mullein - Must be strained with fine mesh or coffee filter",
    inStock: true
  },
  {
    id: 9,
    name: "Calm Storm",
    purpose: "Mind Reset",
    description: "Peace & Clarity. Nervous system support",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/calm_storm_page-1.png",
    imageBack: "/labels/calm_storm_page-2.png",
    benefits: ["Mood Support", "Calming", "Balance"],
    inStock: true
  },
  {
    id: 10,
    name: "Focus Fury",
    purpose: "Brain Fire",
    description: "Mental Clarity. Cognitive enhancement blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/focus_fury_page-1.png",
    imageBack: "/labels/focus_fury_page-2.png",
    benefits: ["Focus", "Mental Energy", "Clarity"],
    inStock: true
  },
  {
    id: 11,
    name: "Clear Current",
    purpose: "Lymph Flow",
    description: "Flow & Detox. Lymphatic system support",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/clear_current_page-1.png",
    imageBack: "/labels/clear_current_page-2.png",
    benefits: ["Lymphatic Health", "Detox", "Circulation"],
    inStock: true
  },
  {
    id: 12,
    name: "BP Balance",
    purpose: "Pressure Steady",
    description: "Heart Health. Cardiovascular support blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/bp_balance_page-1.png",
    imageBack: "/labels/bp_balance_page-2.png",
    benefits: ["Heart Health", "BP Support", "Circulation"],
    inStock: true
  },
  {
    id: 13,
    name: "Nutrient Storm",
    purpose: "Herb Bomb",
    description: "Ultimate Blend. 15 powerful herbs combined",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/nutrient_storm_page-1.png",
    imageBack: "/labels/nutrient_storm_page-2.png",
    benefits: ["Complete Nutrition", "Multi-Benefit", "Energizing"],
    inStock: true
  },
  {
    id: 14,
    name: "Cortisol Crush",
    purpose: "Stress Kill",
    description: "Adapt & Thrive. Stress hormone support",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/cortisol_crush_page-1.png",
    imageBack: "/labels/cortisol_crush_page-2.png",
    benefits: ["Stress Relief", "Adaptogenic", "Calming"],
    inStock: true
  },
  {
    id: 15,
    name: "Golden Ember",
    purpose: "Inflammation Glow",
    description: "Golden Power. Anti-inflammatory superstar",
    price: "$14.99",
    weight: "",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/r53x5i82_1000006412.png",
    benefits: ["Anti-inflammatory", "Liver Support", "Warming"],
    inStock: true
  },
  {
    id: 16,
    name: "Greybeard Mountain Hunter",
    purpose: "Trail Strength",
    description: "Wild Leaf Brew. A rugged blend of Japanese sencha green tea, pine needle, juniper berry, sage, and ginger. Crisp forest aroma with a smooth, warming finish.",
    price: "$14.99",
    weight: "",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/w2rg7t52_1000006403.png",
    benefits: ["Focus", "Strength", "Contains Caffeine"],
    inStock: true
  },
  {
    id: 17,
    name: "Pain Away",
    purpose: "Natural Relief",
    description: "Soothing Comfort. Natural pain relief blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/pain_away_page-1.png",
    imageBack: "/labels/pain_away_page-2.png",
    benefits: ["Pain Relief", "Soothing", "Comfort"],
    inStock: true
  },
  {
    id: 18,
    name: "Ache Breaker",
    purpose: "Muscle & Joint",
    description: "Body Relief. Muscle and joint support blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/ache_breaker_page-1.png",
    imageBack: "/labels/ache_breaker_page-2.png",
    benefits: ["Joint Support", "Muscle Relief", "Flexibility"],
    inStock: true
  },
  {
    id: 19,
    name: "Primal Pulse",
    purpose: "Vitality Boost",
    description: "Raw Power. Primal energy and vitality support",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/primal_pulse_page-1.png",
    imageBack: "/labels/primal_pulse_page-2.png",
    benefits: ["Vitality", "Energy", "Endurance"],
    inStock: true
  },
  {
    id: 20,
    name: "Nutrient Nuke",
    purpose: "Power Packed",
    description: "Maximum Nutrition. Dense nutrient delivery blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/nutrient_nuke_page-1.png",
    imageBack: "/labels/nutrient_nuke_page-2.png",
    benefits: ["Nutrient Dense", "Wellness", "Nourishing"],
    inStock: true
  },
  {
    id: 21,
    name: "Wild Blue Warrior",
    purpose: "Brain Power",
    description: "Warrior Focus. Cognitive and mental clarity blend",
    price: "$14.99",
    weight: "",
    imageFront: "/labels/wild_blue_warrior_page-1.png",
    imageBack: "/labels/wild_blue_warrior_page-2.png",
    benefits: ["Brain Health", "Focus", "Mental Clarity"],
    inStock: true
  },
  {
    id: 22,
    name: "Parasite Purge",
    purpose: "Internal Cleanse",
    description: "Deep Clean. Internal parasite cleansing support",
    price: "$16.99",
    weight: "",
    imageFront: "/labels/parasite_purge_page-1.png",
    imageBack: "/labels/parasite_purge_page-2.png",
    benefits: ["Cleansing", "Detox", "Internal Health"],
    inStock: true
  },
  {
    id: 23,
    name: "Metal Purge",
    purpose: "Heavy Metal Support",
    description: "Deep Detox. Heavy metal chelation support",
    price: "$16.99",
    weight: "",
    imageFront: "/labels/metal_purge_page-1.png",
    imageBack: "/labels/metal_purge_page-2.png",
    benefits: ["Detox Support", "Cleansing", "Chelation"],
    inStock: true
  },
  // Single Herbs Collection - Based on actual Mudbutt Brew products
  {
    id: 24,
    name: "Hibiscus",
    purpose: "Heart Support & Circulation",
    description: "Vibrant ruby-red hibiscus flower that supports circulation and refreshes. Steep 1 tbsp in 8oz hot water for 10-15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/yifxjt68_1000006373.png",
    benefits: ["Heart Health", "Circulation", "Refresh"],
    warning: "May affect blood pressure. Consult your healthcare provider if on medication or pregnant.",
    inStock: true
  },
  {
    id: 25,
    name: "Holy Basil (Tulsi)",
    purpose: "Stress Relief & Mental Clarity",
    description: "Sacred adaptogenic herb that helps the body adapt to stress and supports mental clarity and balance. Steep 1 tbsp in 8oz hot water for 10-15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/xhj1ecqm_1000006375.png",
    benefits: ["Adaptogenic", "Stress Relief", "Mental Clarity", "Balance"],
    warning: "Consult your healthcare provider before use if pregnant, nursing, or on medication.",
    inStock: true
  },
  {
    id: 26,
    name: "Rooibos",
    purpose: "Stress Relief & Circulation",
    description: "South African red bush tea, naturally caffeine-free. Supports stress relief, circulation and balance. Steep 1 tbsp in 8oz hot water for 8-15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/y0r0lm5z_1000006390.png",
    benefits: ["Stress Relief", "Circulation", "Balance", "Caffeine-Free"],
    warning: "Consult your healthcare provider before use if you have an estrogen-sensitive condition.",
    inStock: true
  },
  {
    id: 27,
    name: "Chamomile",
    purpose: "Deep Calm & Gentle Sleep",
    description: "Gentle chamomile flower that promotes deep calm, gentle sleep and relaxation. Steep 1 tbsp in 8oz hot water for 10-15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/0ic2meal_1000006378.png",
    benefits: ["Sleep", "Calming", "Relaxation"],
    warning: "Consult your healthcare provider before use if pregnant, nursing, or on medication.",
    inStock: true
  },
  {
    id: 28,
    name: "Mullein",
    purpose: "Lung Health & Clear Mucus",
    description: "Traditional mullein leaf for lung health, clear mucus and easy breathing. Steep 1 tbsp in 8oz hot water for 15-20 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/1ibagff4_1000006380.png",
    benefits: ["Lung Health", "Respiratory", "Easy Breathing"],
    warning: "Must strain through a fine filter before serving. Consult your healthcare provider before use. Not for long-term use.",
    inStock: true
  },
  {
    id: 29,
    name: "Dandelion",
    purpose: "Detox Support & Digestion",
    description: "Cleansing dandelion root that supports detox, digestion and cleanse. Steep 1 tbsp in 8oz hot water for 15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/io93w2uf_1000006382.png",
    benefits: ["Detox", "Digestive Aid", "Cleansing"],
    warning: "Limit use if pregnant or on diuretics. Consult your healthcare provider before use.",
    inStock: true
  },
  {
    id: 31,
    name: "Fennel",
    purpose: "Gut Ease & Debloat",
    description: "Organic fennel seed for debloating, digestive support and lightness. Steep 1 tbsp in 8oz hot water for 10-15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/jo57f126_1000006392.png",
    benefits: ["Digestive Aid", "Anti-Bloating", "Gut Ease"],
    warning: "Consult your healthcare provider before use if pregnant. May stimulate menstruation.",
    inStock: true
  },
  {
    id: 32,
    name: "Peppermint",
    purpose: "Digestive Ease & Bloat Relief",
    description: "Refreshing peppermint leaf for digestive ease, bloat relief and fresh calm. Steep 1 tbsp in 8oz hot water for 10-15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/18w6bbh4_1000006384.png",
    benefits: ["Digestive Aid", "Anti-Bloating", "Refreshing", "Calming"],
    warning: "May cause acid reflux in sensitive individuals. Use with caution if you have GERD or chronic heartburn.",
    inStock: true
  },
  {
    id: 33,
    name: "Nettle Leaf",
    purpose: "Iron & Minerals",
    description: "Mineral-rich nettle leaf that supports iron levels, digestive health and cleansing. Steep 1 tbsp in 8oz hot water for 10-15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/jcc1y7gp_1000006386.png",
    benefits: ["Energy", "Minerals", "Vitality"],
    warning: "Consult your healthcare provider before use if pregnant or on medication. Use with caution if allergic to plants in Urticaceae family.",
    inStock: true
  },
  {
    id: 34,
    name: "Lemon Balm",
    purpose: "Stress Relief & Mood Lift",
    description: "Organic lemon balm leaf for stress relief, mood lift and focus. Steep 1 tbsp in 8oz hot water for 10-15 minutes, covered.",
    price: "$10.00",
    weight: "",
    category: "single-herb",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/c7r9x065_1000006388.png",
    benefits: ["Stress Relief", "Mood Support", "Focus"],
    warning: "Consult your healthcare provider before use if pregnant, taking sedatives, or have hypothyroidism.",
    inStock: true
  },
  {
    id: 35,
    name: "Moonlit Lotus",
    purpose: "Energy Without the Crash",
    description: "Cold brew energy tea for sustained energy without the crash. A unique herbal blend of Dried Lotus Flower Petals, Green Tea, Ginseng Root, and Lemon Balm Leaf for natural vitality.",
    price: "$14.99",
    weight: "",
    imageFront: "https://customer-assets.emergentagent.com/job_9cfaf4ea-95ef-4e3c-a721-dd4a985ef375/artifacts/clv7gpbc_1000006367.jpg",
    benefits: ["Energy", "Focus", "Vitality", "No Crash"],
    warning: "Contains caffeine from Green Tea. Cold brew: steep in cold water 6-8 hours or overnight.",
    inStock: true
  }
];

export const benefits = [
  {
    title: "100% Natural",
    description: "Wild-crafted and organic herbs from trusted sources",
    icon: "Leaf"
  },
  {
    title: "Artisan Crafted",
    description: "Hand-blended in small batches for maximum potency",
    icon: "Sprout"
  },
  {
    title: "Elma Rooted",
    description: "Proudly crafted in Elma, Washington",
    icon: "Award"
  },
  {
    title: "Traditional Wisdom",
    description: "Ancient herbal knowledge meets modern needs",
    icon: "Recycle"
  }
];

// Mock form submission
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Thank you for your inquiry! We'll respond within 24 hours." });
    }, 1000);
  });
};
